import script from "./MapSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./MapSwiper.vue?vue&type=script&setup=true&lang=js"

import "./MapSwiper.vue?vue&type=style&index=0&id=1b336190&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b336190"]])

export default __exports__